// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/next-page/next-page.scss
 ** module id = 98
 ** module chunks = 0 1
 **/